import { useAsyncData, useNuxtApp, useRoute } from '#imports'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useMasterPP } from '~/scopes/product-core/composables/useMasterPP/useMasterPP'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchProduct(route = useRoute()) {
  const nuxtApp = useNuxtApp()
  const { productId } = useUrlParams(route)
  const $httpFetch = useHttpFetch()
  const { isMasterPPUrl } = useMasterPP(route)

  const partnerId =
    typeof route.query.utm_source === 'string' ? route.query.utm_source : null

  return useAsyncData(
    () => `pp-product-${productId}`,
    async () =>
      await $httpFetch('/product-page/products/:productId', {
        pathParams: { productId },
        query: {
          partnerId,
        },
      }),

    {
      default: () => undefined,
      transform: (p: GetProductResponse) => {
        if (isMasterPPUrl.value) {
          return {
            ...p,
            titles: {
              ...p.titles,
              raw: p.titles.default,
            },
          }
        }

        return p
      },
      dedupe: 'defer',
      getCachedData: (key) => nuxtApp.payload.data[key],
    },
  )
}
